import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { doNothingAsync } from '../../../helpers/function.helpers';
import { ImageSetType } from '../../projectDetails/sub/images/projectDetailsImages.model';
import { IAnnotationService } from '../annotation.service';
import { IAnnotationsStore } from '../annotations.store';
import { AnnotationStatusInfo } from '../components/AnnotationStatusInfo';
import { IClarificationsStore } from '../submodules/clarifications/Clarifications.store';
import { ClarificationsContainer } from '../submodules/clarifications/containers/Clarifications.container';

interface IProps {
  canChangeImageSet: boolean;
}

export const AnnotationStatusInfoContainer = observer(({ canChangeImageSet }: IProps): ReactElement => {
  const annotationsStore = useInjection(IAnnotationsStore.$);
  const clarificationsStore = useInjection(IClarificationsStore.$);
  const annotationService = useInjection(IAnnotationService.$);

  const handleImageSetChange = async (id: string, type: ImageSetType): Promise<void> => {
    await annotationService.updateProjectImageSetAsync(id, type);
  };

  const imageId = annotationsStore.image?.id;

  return (
    <div className='set-navigation-container'>
      <AnnotationStatusInfo
        isImageLoaded={!!annotationsStore.image}
        annotationStatus={annotationsStore.image?.annotations?.status}
        isAssigned={annotationsStore.image?.annotations?.isAssigned || false}
        annotatedByName={annotationsStore.image?.annotations?.author || ''}
        reviewedByName={annotationsStore.image?.annotations?.reviewedByName || ''}
        reviewRejectionReason={annotationsStore.image?.annotations?.reviewRejectionReason}
        hasUnansweredClarification={clarificationsStore.hasUnansweredClarification}
        isWaitingForReviewAfterReject={annotationsStore.image?.annotations?.isWaitingForReviewAfterReject || false}
        imageSet={canChangeImageSet ? (annotationsStore.image?.imageSet ?? ImageSetType.NotSet) : undefined}
        onImageSetChange={
          imageId
            ? async (set): Promise<void> => {
                await handleImageSetChange(imageId, set);
              }
            : doNothingAsync
        }
        enableImageSetChange={canChangeImageSet}
      />
      <ClarificationsContainer />
    </div>
  );
});
